export default __webpack_public_path__ + "static/media/balmain_runway.fc1e409e.jpg";